// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".iconsvg[data-v-50106dce]{display:block;width:20px;height:20px;font-size:0}\n", ""]);
// Exports
module.exports = exports;
